export default {"src":"/_next/static/image/public/images/ic_user.5d9916e0be89e6b1904219c3f269ee10.svg","height":34,"width":34};